var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEthics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.368,
    height: 60.708,
    viewBox: "0 0 69.368 60.708",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62775",
    "data-name": "Group 62775",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62772",
    "data-name": "Group 62772",
    transform: "translate(0 20.426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62771",
    "data-name": "Group 62771",
    transform: "translate(2.754)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2200",
    "data-name": "Line 2200",
    x1: 10.34,
    y2: 23.721,
    fill: "none",
    stroke: "#00a6ef",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2201",
    "data-name": "Line 2201",
    x2: 10.34,
    y2: 23.721,
    transform: "translate(10.644)",
    fill: "none",
    stroke: "#00a6ef",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_107809",
    "data-name": "Path 107809",
    d: "M128.082,99.607c-.007.2-.055.376-.055.571a13.081,13.081,0,0,0,26.161,0c0-.2-.052-.376-.059-.571Z",
    transform: "translate(-128.027 -74.975)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fff",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62774",
    "data-name": "Group 62774",
    transform: "translate(41.207 9.174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62773",
    "data-name": "Group 62773",
    transform: "translate(2.754)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2202",
    "data-name": "Line 2202",
    x1: 10.34,
    y2: 23.721,
    fill: "none",
    stroke: "#00a6ef",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2203",
    "data-name": "Line 2203",
    x2: 10.34,
    y2: 23.721,
    transform: "translate(10.644)",
    fill: "none",
    stroke: "#00a6ef",
    strokeLinecap: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_107810",
    "data-name": "Path 107810",
    d: "M139.27,96.552c-.007.2-.055.376-.055.571a13.081,13.081,0,0,0,26.161,0c0-.2-.048-.376-.059-.571Z",
    transform: "translate(-139.215 -71.92)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fff",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_107811",
    "data-name": "Path 107811",
    d: "M0,11.252,41.207,0",
    transform: "translate(13.094 9.174)",
    fill: "none",
    stroke: "#00a6ef",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2205",
    "data-name": "Line 2205",
    y2: 14.8,
    transform: "translate(31.83 0)",
    fill: "none",
    stroke: "#00a6ef",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthics);
export default __webpack_public_path__ + "static/media/ethics.c4f185c58b363b6ed3a3aef0f5228bc7.svg";
export { ForwardRef as ReactComponent };